import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import monitor from '@tencent/vft-monitor';
import LJReport from '@tencent/vft-speedreport/LJReport';
import env from '../env';
export default {
  fatal: function fatal(params) {
    monitor.getMonitor('h5-login').fatal(_objectSpread({
      modId: 'request_error'
    }, params));
  },
  getPerf: function getPerf() {
    return new LJReport({
      project: 'video_vip_fe',
      page: 'h5-login'
    });
  },
  perf: function perf() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        modId = _ref.modId,
        metrics = _ref.metrics,
        tags = _ref.tags;

    var reporter = new LJReport({
      project: 'video_vip_fe',
      page: 'h5-login'
    });
    reporter.report({
      modId: modId,
      metrics: metrics,
      tags: _objectSpread({
        device: env.device,
        app: env.app
      }, tags)
    });
  }
};